import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  inlineKeyString1hdvsz76w276 as inlineKeyString,
  htmlKeyString3qkhbon8qnk4f as htmlKeyString,
} from '../keyValue.mjs';
import {
  renderBanners1vh1dpq8pq90j as renderBanners,
  banners2ndq1wx79ibxx as banners,
} from '../../../utils/Banner.mjs';
import {
  ProjectState_Locked_getInstance2lzy284wfpx83 as ProjectState_Locked_getInstance,
  ProjectState_TransferringFunds_getInstance1fufy8va5bpur as ProjectState_TransferringFunds_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  ProjectState_RequestingComplete_getInstance29ba44myrjzuw as ProjectState_RequestingComplete_getInstance,
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_project24re8n4hoe63y as get_project } from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function projectLevelMessages(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var tmp = shownWhen(writer, VOID, ($this$shownWhen) => $this$shownWhen.baj(_this__u8e3s4.lgj_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(_this__u8e3s4.egi_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().pg2_1);
  body(view_0, 'Welcome to Stoze, your escrow solution!');
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_0.fbb(p_1, view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
  inlineKeyString(view_2, 'New Users', 'Register to create an account. Once registered, log in to review and accept your project.');
  view_0.fbb(p_2, view_2);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  inlineKeyString(view_3, 'Returning Users', 'Log in to securely access and accept your project.');
  view_0.fbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_0.fbb(p_4, view_4);
  body(view_0, 'After logging in, you\u2019ll be able to view project details and proceed with the next steps.');
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  renderBanners(view, get_banners(_this__u8e3s4));
  writer.fbb(p, view);
  return writer.jbb(tmp, view);
}
function get_banners(_this__u8e3s4) {
  return _this__u8e3s4.sgj('project-level-banners', () => remember(VOID, VOID, VOID, ($this$remember) => banners(($this$banners) => {
    var state = $this$remember.baj(_this__u8e3s4.agj_1);
    var tmp;
    if (state.equals(ProjectState_Locked_getInstance())) {
      $this$banners.zfz('PL-Locked', 'This project is locked. All work and fund releases are frozen. Stoze holds funds securely as a neutral escrow agent. To resolve: reach notarized mutual agreement in writing or enter formal binding dispute resolution (either party can initiate at their discretion). Stoze will disburse funds only per notarized mutual agreement or final resolution decision. Contact help@stoze.io with questions.');
      // Inline function 'kotlin.let' call
      var it = $this$remember.baj(_this__u8e3s4.ugj());
      if (!(it == null) && !(it.p86_1 === _this__u8e3s4.rgj().xgj())) {
        $this$banners.xfz('PL-Unlock-Request', 'The ' + (_this__u8e3s4.rgj().xgj() ? 'contractor' : 'client') + ' has submitted a formal request to unlock the project. Click "Review Unlock Request" and respond.');
      }
      return Unit_instance;
    }
    var tmp_0;
    if (state.equals(ProjectState_TransferringFunds_getInstance())) {
      $this$banners.xfz('PL-TransferringFunds', 'Funds are being transferred securely. During the transfer process, your project status will be locked to ensure security. Once funds settle the project status will update to Pending Start and will be able to be started by the contractor. Allow 2-3 days for funds to settle.');
      return Unit_instance;
    }
    var tmp_1;
    if (_this__u8e3s4.rgj().xgj()) {
      var tmp_2;
      if ($this$remember.baj(_this__u8e3s4.ugi_1)) {
        $this$banners.xfz('H-PL-CanAccept', 'Accepting a project awards the project and allows your contractor to send an escrow deposit request before starting.');
        tmp_2 = Unit_instance;
      } else {
        if ($this$remember.baj(_this__u8e3s4.ggi_1)) {
          $this$banners.ufz('H-PL-AwaitingFundsRequest', ($this$info) => {
            var c = $this$info.baj(_this__u8e3s4.fgl());
            return "Congratulations! You've awarded the job to " + c.x5i_1 + '. They have been notified of your acceptance and will request project funding within 10 business days before anticipated project start. You are now officially on your ' + c.d5j_1.toString() + "'s schedule.";
          });
          tmp_2 = Unit_instance;
        } else {
          var tmp0 = $this$remember.baj(_this__u8e3s4.tgj());
          var tmp$ret$2;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_3;
            if (isInterface(tmp0, Collection())) {
              tmp_3 = tmp0.i1();
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              tmp$ret$2 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var deposited = MonetaryValue__plus_impl_c1ylt(element.l61_1, element.k61_1);
              if (MonetaryValue__compareTo_impl_w7ul1r(deposited, Companion_instance.o62(0)) > 0 && MonetaryValue__compareTo_impl_w7ul1r(deposited, element.i61_1) < 0) {
                tmp$ret$2 = true;
                break $l$block_0;
              }
            }
            tmp$ret$2 = false;
          }
          if (tmp$ret$2) {
            var payments = remember(VOID, VOID, VOID, ($this$remember) => {
              var tmp0_safe_receiver = $this$remember.baj(get_rawSession());
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qfv_1;
              var tmp;
              if (tmp1_safe_receiver == null) {
                tmp = null;
              } else {
                // Inline function 'com.lightningkite.lightningdb.Query' call
                // Inline function 'kotlin.collections.listOf' call
                var orderBy = emptyList();
                // Inline function 'com.lightningkite.lightningdb.path' call
                // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
                var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
                var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
                var it = new (DataClassPathSelf())(tmp$ret$5);
                var tmp$ret$7 = eq(get_project(it), _this__u8e3s4.jf8());
                var tmp$ret$8 = new (Query())(tmp$ret$7, orderBy, 0, 100);
                tmp = tmp1_safe_receiver.feo(tmp$ret$8);
              }
              var tmp2_safe_receiver = tmp;
              // Inline function 'kotlin.collections.orEmpty' call
              var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : $this$remember.baj(tmp2_safe_receiver);
              return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            });
            $this$banners.vfz('H-PL-FundsRequested-Below', ($this$warn) => {
              var requests = $this$warn.baj(_this__u8e3s4.tgj());
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum = Companion_instance.p91(0n);
              var _iterator__ex2g4s = requests.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                var tmp = sum;
                var tmp$ret$10 = MonetaryValue__plus_impl_c1ylt(element.l61_1, element.k61_1);
                sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$10);
              }
              var paid = sum;
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum_0 = Companion_instance.p91(0n);
              var _iterator__ex2g4s_0 = requests.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                var tmp_0 = sum_0;
                var tmp$ret$12 = element_0.i61_1;
                sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$12);
              }
              var full = sum_0;
              return "<strong>We've received your " + ($this$warn.baj(payments).p1() > 1 ? 'payments' : 'payment') + ' of ' + MonetaryValue__toString_impl_xslc77(paid) + '.<\/strong> Your contractor requested ' + MonetaryValue__toString_impl_xslc77(full) + ' total for this project. To move your project forward, please send the remaining ' + MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(full, paid)) + ' by check or wire using your project reference number (' + $this$warn.baj(_this__u8e3s4.jfy()).o97() + ').';
            });
            tmp_2 = Unit_instance;
          } else {
            if (state.d4(ProjectState_InProgress_getInstance()) < 0 && $this$remember.baj(_this__u8e3s4.hgi_1)) {
              $this$banners.xfz('H-PL-FundsRequested', "It's time to fund your project. Send escrow funds by check or wire to make sure your project is not delayed or canceled. Once Stoze receives the requested amount, your project will move to Pending Start and your contractor can begin work.");
              tmp_2 = Unit_instance;
            } else {
              if (state.equals(ProjectState_PendingStart_getInstance())) {
                $this$banners.ufz('H-PL-PendingStart-info', ($this$info) => MonetaryValue__toString_impl_xslc77($this$info.baj(_this__u8e3s4.jfy()).c7c_1) + ' has been safely deposited to Stoze for escrow protection. Your contractor can now begin mobilization plans and other preparations required to start your project.');
                $this$banners.yfz('H-PL-PendingStart-warn', 'Once the contractor starts items in Stoze the project status updates to In Progress. Just because your contractor is not physically on site does not mean they have not started. Ordering materials or mobilizing crews would be considered as started.');
                tmp_2 = Unit_instance;
              } else {
                if (state.equals(ProjectState_InProgress_getInstance())) {
                  $this$banners.xfz('H-PL-InProgress-info', trimIndent('\n                        The contractor has started items, and the project is now in progress.\n                        \n                        ' + htmlKeyString('Work Items', "Items move to 'Working' status once started.") + '\n                        ' + htmlKeyString('Next Steps', 'After work is completed, the contractor will request your sign-off for approval.') + '\n                    '));
                  $this$banners.yfz('H-PL-InProgress-warn', trimIndent('\n                        Stay on top of your alerts and emails to follow work items as they progress.\n                        \n                        ' + htmlKeyString('Approval Process', "Review each work item promptly and approve or send it back as 'Not Ready' if changes are needed.") + '\n                        ' + htmlKeyString('Auto-Approval', 'If no action is taken within 14 days, the item will auto-approve, and funds will be released to the contractor.') + '\n                    '));
                  tmp_2 = Unit_instance;
                } else {
                  if ($this$remember.baj(_this__u8e3s4.igi_1)) {
                    $this$banners.xfz('H-PL-SubstantialCompletion', 'All work items are complete \u2014 your project is now in <strong>Substantial Completion<\/strong>.\n\n\u2022 The contractor may conduct final checks, address punch tasks, confirm warranty details, and finish cleanup.\n\u2022 Review the project carefully to ensure everything meets your expectations.\n\u2022 A request for final completion will be sent soon for your approval.\n\nMinor issues arise that don\u2019t impact the project\u2019s functionality, may be best handled as part of a warranty after completion. Use Stoze\u2019s messaging to work with your contractor and document any concerns. ');
                    tmp_2 = Unit_instance;
                  } else {
                    if ($this$remember.baj(_this__u8e3s4.jgi_1)) {
                      $this$banners.xfz('H-PL-RequestedComplete', 'Your contractor has requested Final Completion of the project.\n\nReview the completed work, including any punch tasks, and prepare to approve. If needed, click Raise Issue for any outstanding items. If minor adjustments arise that don\u2019t affect the project\u2019s functionality, ask the contractor if that should be covered as a warranty rather than delaying completion.  \n\nRetention funds (if applicable) will be released upon your approval, and the project will be marked as complete.');
                      tmp_2 = Unit_instance;
                    } else {
                      if (state.equals(ProjectState_Complete_getInstance())) {
                        $this$banners.xfz('H-PL-Complete', 'Congratulations! Your project is complete. All funds, including retention, can be collected by your contractor and you have record of payment.  \n\nThank you for using Stoze to protect your project. For any warranty or future concerns contactor contractor directly.  ');
                        var tmp_4;
                        if ($this$remember.baj(_this__u8e3s4.ogi_1) && MonetaryValue__compareTo_impl_w7ul1r($this$remember.baj(_this__u8e3s4.pgi_1).a5s_1, Companion_instance.p91(0n)) > 0) {
                          $this$banners.xfz('H-PL-Refunds', 'You have ' + MonetaryValue__toString_impl_xslc77($this$remember.baj(_this__u8e3s4.pgi_1).a5s_1) + ' available for disbursement.');
                          tmp_4 = Unit_instance;
                        }
                        tmp_2 = tmp_4;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      tmp_1 = tmp_2;
    } else {
      var tmp_5;
      if (setOf([ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance()]).t1(state)) {
        $this$banners.xfz('C-PL-WaitingApproval', 'This project is locked while waiting for the client to accept. No edits to work items, creating tasks, or other project details can be altered at this time.\n\nIf the client requests changes to accept the project, unpublish the current invite link, make the necessary edits, and send a new invitation.');
        tmp_5 = Unit_instance;
      } else if ($this$remember.baj(_this__u8e3s4.ggi_1)) {
        $this$banners.ufz('C-PL-AwaitingFundsRequest-info', ($this$info) => "Congratulations - you've got work! " + $this$info.baj(_this__u8e3s4.wgk()).f5c_1 + ' has awarded you "' + $this$info.baj(_this__u8e3s4.jfy()).d7b_1 + '". Don\'t forget to request funds before starting.');
        $this$banners.yfz('C-PL-AwaitingFundsRequest-warn', "We've notified your client that funds should not be requested more than 10 days before site arrival or material purchases. Checks and wires typically take up to a week to be received and processed. Plan accordingly.");
        tmp_5 = Unit_instance;
      } else if ($this$remember.baj(_this__u8e3s4.hgi_1) && state.d4(ProjectState_TransferringFunds_getInstance()) <= 0) {
        var requests = $this$remember.baj(_this__u8e3s4.tgj());
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s_0 = requests.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var tmp_6 = sum;
          var tmp$ret$14 = element_0.i61_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_6, tmp$ret$14);
        }
        var requested = sum;
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum_0 = Companion_instance.p91(0n);
        var _iterator__ex2g4s_1 = requests.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          var tmp_7 = sum_0;
          var tmp$ret$16 = element_1.l61_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_7, tmp$ret$16);
        }
        var deposited_0 = sum_0;
        var tmp_8;
        if (MonetaryValue__compareTo_impl_w7ul1r(deposited_0, Companion_instance.o62(0)) <= 0) {
          $this$banners.ufz('C-PL-FundsRequested', ($this$info) => {
            var project = $this$info.baj(_this__u8e3s4.jfy());
            return project.b7c_1 === project.y7b_1 ? trimIndent('\n                                <strong>Funding Requested: ' + MonetaryValue__toString_impl_xslc77(project.b7c_1) + "<\/strong>\n                                \n                                You've requested " + MonetaryValue__toString_impl_xslc77(project.b7c_1) + " from your client. They'll send a check or wire to Stoze using the project reference number (" + project.o97() + '). Once Stoze receives the requested amount, the project will move to Pending Start.\n\n                                You can rescind the funds request to return to Awarded status, or cancel the project.\n\n                                <i>Checks and wires typically take up to a week to be received and processed.<\/i>\n                            ') : trimIndent('\n                                <strong>Funding Requested: ' + MonetaryValue__toString_impl_xslc77(project.b7c_1) + ' of ' + MonetaryValue__toString_impl_xslc77(project.y7b_1) + "<\/strong> \n                                \n                                You've requested " + MonetaryValue__toString_impl_xslc77(project.b7c_1) + " from your client. They'll send a check or wire to Stoze using the project reference number (" + project.o97() + '). Once Stoze receives the requested amount, the project will move to Pending Start.\n\n                                You can rescind the funds request to return to Awarded status, or cancel the project.\n\n                                <i>Checks and wires typically take up to a week to be received and processed.<\/i>\n                            ');
          });
          tmp_8 = Unit_instance;
        } else if (MonetaryValue__compareTo_impl_w7ul1r(deposited_0, requested) < 0) {
          $this$banners.ufz('C-PL-FundsRequested-Below', ($this$info) => {
            // Inline function 'kotlin.text.buildString' call
            // Inline function 'kotlin.apply' call
            var this_0 = StringBuilder().d1();
            this_0.wb('<strong>' + MonetaryValue__toString_impl_xslc77(deposited_0) + ' received toward your ');
            if (requests.p1() > 1)
              this_0.wb('funding requests totalling ' + MonetaryValue__toString_impl_xslc77(requested));
            else
              this_0.wb(MonetaryValue__toString_impl_xslc77(requested) + ' funding request');
            this_0.wb('.<\/strong> ');
            this_0.wb(MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(requested, deposited_0)) + " remains outstanding. The project will move to Pending Start once the full requested amount is received. We've notified your client.");
            return this_0.toString();
          });
          tmp_8 = Unit_instance;
        }
        tmp_5 = tmp_8;
      } else if (state.equals(ProjectState_PendingStart_getInstance())) {
        $this$banners.vfz('C-PL-PendingStart', ($this$warn) => {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().d1();
          // Inline function 'kotlin.text.appendLine' call
          var value = MonetaryValue__toString_impl_xslc77($this$warn.baj(_this__u8e3s4.jfy()).c7c_1) + " has been deposited into Stoze. You've got the green light to get started.";
          // Inline function 'kotlin.text.appendLine' call
          this_0.wb(value).xb(_Char___init__impl__6a9atx(10));
          // Inline function 'kotlin.text.appendLine' call
          this_0.xb(_Char___init__impl__6a9atx(10));
          // Inline function 'kotlin.text.appendLine' call
          var value_0 = "Now is the time to begin planning for mobilization, materials and crews. Don't forget to keep communicating.";
          // Inline function 'kotlin.text.appendLine' call
          this_0.wb(value_0).xb(_Char___init__impl__6a9atx(10));
          // Inline function 'kotlin.text.appendLine' call
          this_0.xb(_Char___init__impl__6a9atx(10));
          // Inline function 'kotlin.text.appendLine' call
          var value_1 = 'You must start a work item for the project status to update to In Progress.';
          // Inline function 'kotlin.text.appendLine' call
          this_0.wb(value_1).xb(_Char___init__impl__6a9atx(10));
          return this_0.toString();
        });
        tmp_5 = Unit_instance;
      } else if ($this$remember.baj(_this__u8e3s4.igi_1)) {
        $this$banners.xfz('C-PL-SubstantialCompletion-info', "Your project is now in the Substantial Completion phase.\n\nFocus on resolving all punch list items, leaving the workspace clean, and ensuring everything meets the client\u2019s expectations. Use this time to finalize any details and set the stage for a smooth approval process.\n\nAll punch list items marked as 'Required' must be marked as complete to request Final Completion. Retention funds, if any, will be released upon the client\u2019s acceptance of Final Completion.");
        var tmp_9;
        if (!$this$remember.baj(_this__u8e3s4.fgi_1)) {
          $this$banners.yfz('C-PL-SubstantialCompletion-warn', 'There are remaining funds that have not been paid on the project. The client will not be able to accept the project as complete until they pay the remaining balance.');
          tmp_9 = Unit_instance;
        }
        tmp_5 = tmp_9;
      } else if (state.equals(ProjectState_RequestingComplete_getInstance())) {
        $this$banners.xfz('C-PL-RequestingComplete-info', 'Your project is now in the Pending Complete phase.\n\nThe client is reviewing the work for final acceptance. Respond and address any Raised Issues promptly to avoid a project dispute.  \n\nClear and proactive communication can help resolve questions or issues quickly, ensuring a smooth completion and the release of retention funds. For minor concerns or non-critical adjustments, be ready to outline how they will be addressed during the warranty phase.        ');
        var tmp_10;
        if (!$this$remember.baj(_this__u8e3s4.fgi_1)) {
          $this$banners.yfz('C-PL-RequestingComplete-FundingNeeded-warn', 'There are remaining funds that have not been paid on the project. The client will not be able to accept the project as complete until they pay the remaining balance.');
          tmp_10 = Unit_instance;
        } else {
          $this$banners.yfz('C-PL-RequestingComplete-warn', 'Follow up with the client to ensure any outstanding concerns are resolved. Retention funds will be released once the client approves final completion. For minor issues, consider offering resolution during the warranty phase to avoid delays.');
          tmp_10 = Unit_instance;
        }
        tmp_5 = tmp_10;
      } else if (state.equals(ProjectState_Complete_getInstance())) {
        $this$banners.xfz('C-PL-Complete', 'Congratulations! The project is complete and all funds have been released. Funds can be collected on the Finances page.   \n\nThanks for using Stoze to protect your project.');
        tmp_5 = Unit_instance;
      }
      tmp_1 = tmp_5;
    }
    return Unit_instance;
  })));
}
//region block: exports
export {
  projectLevelMessages as projectLevelMessagesrgqtjljm2k9u,
};
//endregion

//# sourceMappingURL=projectLevelMessages.mjs.map
